import { useMemo, type CSSProperties } from "react";
import { range, rand } from "../utils/random";
import type { EffectProps } from "./types";

export function FloatingBows({ count = 22 }: EffectProps = {}) {
  const bows = useMemo(
    () =>
      range(count).map(i => ({
        id: i,
        left: `${rand(0, 100)}vw`,
        size: `${rand(20, 44)}px`,
        riseDuration: `${rand(10, 18)}s`,
        delay: `${rand(-18, 0)}s`,
        opacity: rand(0.7, 1),
      })),
    [count],
  );

  return (
    <div className="fx-layer" aria-hidden>
      {bows.map(b => (
        <span
          key={b.id}
          className="fx-particle fx-bow"
          style={
            {
              left: b.left,
              top: 0,
              fontSize: b.size,
              opacity: b.opacity,
              animationDuration: b.riseDuration,
              animationDelay: b.delay,
            } as CSSProperties
          }
        >
          🎀
        </span>
      ))}
    </div>
  );
}
